import { render, staticRenderFns } from "./ApproveOrRejectCeEntry.vue?vue&type=template&id=37115486&"
import script from "./ApproveOrRejectCeEntry.vue?vue&type=script&lang=js&"
export * from "./ApproveOrRejectCeEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports